var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgEmergencyShutdown = function SvgEmergencyShutdown(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#CB366D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.983 7.534 7.095 13.478a1 1 0 0 1-.885 1.466H9.003a1 1 0 0 1-.885-1.466l7.095-13.478a1 1 0 0 1 1.77 0Zm-2.655-.466c.75-1.424 2.79-1.424 3.54 0l7.095 13.478c.701 1.332-.265 2.932-1.77 2.932H9.003c-1.505 0-2.471-1.6-1.77-2.932l7.095-13.478Zm1.768 12.565a.694.694 0 0 1-.537-.235.841.841 0 0 1-.212-.58c0-.236.072-.433.212-.588a.694.694 0 0 1 .537-.234c.217 0 .4.08.54.235.14.154.213.351.213.586 0 .23-.072.427-.212.581a.704.704 0 0 1-.541.235Zm-.665-6.987a.668.668 0 1 1 1.334 0l-.208 4.092a.46.46 0 0 1-.918 0l-.208-4.092Z",
    fill: "#fff"
  })));
};
export default SvgEmergencyShutdown;